import { Divider } from "@material-ui/core";

const parseTitle = (title) => {
  if (!title) return "";
  const regex = /<i class="([^"]+)"[^>]*><\/i>/g;
  let elements = [];
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(title)) !== null) {
    if (match.index > lastIndex) {
      elements.push(title.substring(lastIndex, match.index));
    }
    elements.push(<i key={match.index} className={match[1]} />);
    regex.lastIndex < title.length &&
      elements.push(
        <Divider
          key={`divider-${match.index}`}
          orientation="vertical"
          style={{
            margin: "0 0.5rem",
            height: "1rem",
            color: "#ffffff80",
            width: "2px",
          }}
        />
      );
    lastIndex = regex.lastIndex;
  }
  if (lastIndex < title.length) {
    elements.push(title.substring(lastIndex));
  }
  return elements.length > 0 ? elements : title;
};

export default parseTitle;
